import styled from 'styled-components';

export const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const InputsContainer = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;
